import React from 'react';

export default function SendIcon03({ fill, ...restProps }) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill={fill ?? ''}
      xmlns='http://www.w3.org/2000/svg'
      {...restProps}
    >
      <path
        d='M2.332 2.512a1.45 1.45 0 0 0-.895.882c-.071.189-.082.286-.067.586.018.345.073.523 1.297 4.2l1.279 3.84-1.282 3.84-1.282 3.84-.001.4c-.001.351.012.428.106.628.322.686 1.078.989 1.84.737.373-.124 17.845-7.979 18.146-8.158.497-.296.766-.702.798-1.203.044-.688-.274-1.153-1.052-1.537-.591-.292-17.515-7.897-17.799-7.999-.375-.134-.807-.156-1.088-.056m9.321 5.928c4.327 1.947 7.867 3.549 7.867 3.561 0 .012-3.565 1.625-7.923 3.586-4.357 1.961-7.915 3.545-7.906 3.519.01-.025.471-1.409 1.026-3.076L5.727 13h2.486l2.487-.001.2-.094c.381-.181.588-.5.588-.905 0-.385-.195-.703-.548-.894-.158-.085-.191-.086-2.697-.106l-2.536-.02L4.713 8 3.696 4.946c-.017-.051-.006-.069.034-.06.032.008 3.597 1.607 7.923 3.554'
        fill-rule='evenodd'
        fill={fill ?? ''}
      />
    </svg>
  );
}
